<template>
  <b-modal
      id="modalViewBoleto"
      ref="modalViewBoleto"
      title="Boleto"
      @hide="resetViewModal"
      cancel-title="Voltar"
      ok-title="Download"
      @ok="downloadBoleto"
      size="lg"
      centered
      scrollable
  >
    <b-overlay
        :show="$store.state.BoletoStore.generetedBoletoLoading && $store.state.BoletoStore.generatedBoletoUrl === ''"
        spinner-variant="primary"
        spinner-type="grow"
        spinner-small
        rounded="sm"
    >
      <div class="flex justify-center"  v-show="!$store.state.BoletoStore.generetedBoletoLoading && $store.state.BoletoStore.generatedBoletoUrl !== ''">
        <iframe :src="$store.state.BoletoStore.generatedBoletoUrl" width="100%" height="600px"></iframe>
      </div>

    </b-overlay>
  </b-modal>
</template>

<script>
import {
  BModal, BCard, BCardHeader, BCardBody, BTable, BButton,
} from 'bootstrap-vue';
import { mapActions } from 'vuex';

export default {
  name: 'modalViewBoleto',
  components: {
    BModal,
    BCard,
    BCardHeader,
    BCardBody,
    BTable,
    BButton,
  },

  data() {
    return {
    };
  },
  methods: {
    async showModalViewBoleto() {
      await this.$bvModal.show('modalViewBoleto');
    },
    async downloadBoleto() {
      window.open(this.$store.state.BoletoStore.generatedBoletoUrl, '_blank');
    },

    async resetViewModal() {
      this.$store.commit('BoletoStore/SET_GENERATED_URL', '');
    },
  },
};
</script>

<style scoped>
/* Adicione estilos se necessário */
</style>
